export default "__VITE_ASSET__DLobJB$V__"